export const EmptyInput=()=>{
    return(
        // <input type="text" className="form-control" readOnly />
        <p></p>
    )
}